export default "__VITE_ASSET__BrYTHZnd__"